import React from 'react';
import { FormGroup, Input, Button } from '@tencent/spaui';

import { RPCFactory } from '../../../utils/RequestUtil';
import { PageUtil } from '../../../utils/PageUtil';
import TipMsg from '../../../consts/TipMsg';
import { GlobalStateAction } from '../../../actions/GlobalStateAction';
import { store } from '../../../store/Store';
import { Common } from '../../../consts/Common';
import TipsType from '../../../consts/TipsType';

export default class SecondLoginPage extends React.Component {
  /**
   * 获取当前二次密码状态：
   * 1、如果已设置二次密码并且当前二次密码未登录，则展示
   */
  componentDidMount() {
    RPCFactory.sso.getSecondLoginStateInfo().done((data) => {
      const { mobile } = data;
      const { secondLogined } = data;
      if (!mobile || secondLogined) {
        PageUtil.gotoAdvertiser();
        return;
      }

      this.setState({ mobile });
    });
  }

  constructor(props) {
    super(props);
    this.state = {
      psw: '',
      pswHelpBlock: '',

      mobile: '',
    };
  }

  onChangePassword = (value) => {
    this.setState({ psw: value, pswHelpBlock: '' });
  };

  onSubmitSecondPsw = (e) => {
    const { psw } = this.state;
    if (!psw) {
      this.setState({ pswHelpBlock: TipMsg.SECOND_PSW_ERROR });
      return;
    }
    RPCFactory.sso
      .secondLoginCheck(psw)
      .done((data) => {
        PageUtil.gotoAdvertiser();
      })
      .fail((ret, msg) => {
        this.setState({ pswHelpBlock: msg });
      });
  };

  sendPsw = (e) => {
    RPCFactory.account
      .sendPsw()
      .done((data) => {
        const successMsg = TipMsg.SEND_SECRET_SUC;
        store.dispatch({
          type: GlobalStateAction.SHOW_TIPS,
          message: successMsg,
          time: Common.DURATION_2_SEC,
          tipsType: TipsType.SUCCESS.getCode(),
        });
      })
      .fail((ret, msg) => {
        store.dispatch({
          type: GlobalStateAction.SHOW_TIPS,
          message: msg,
          time: Common.DURATION_2_SEC,
          tipsType: TipsType.ERROR.getCode(),
        });
      });
  };

  render() {
    return (
      <div className={'panel-set-pwd'}>
        <div className={'item-group '}>
          <label className="label-name">
            <em>账号已设置独立密码保护，请填写独立密码</em>
          </label>
          <FormGroup helpBlock={this.state.pswHelpBlock} status={this.state.pswHelpBlock ? 'error' : ''}>
            <Input
              placeholder="请输入独立密码"
              type="password"
              maxLength="64"
              value={this.state.psw}
              onChange={(e, value) => {
                this.onChangePassword(value);
              }}
            />
            <Button displayType="primary" onClick={this.onSubmitSecondPsw}>
              确定
            </Button>
          </FormGroup>
          <div className="info">
            忘记密码？请联系管理员（手机：{this.state.mobile}）<a onClick={this.sendPsw}>获取密码</a>
          </div>
        </div>
      </div>
    );
  }
}
